// extracted by mini-css-extract-plugin
export default {"search":"SearchMainPage_search__5wn7R","form":"SearchMainPage_form__xAqrQ"};